module.exports = __webpack_public_path__ + "static/media/handle-default.7dc06f2b.png";